var _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#EBFFF3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48.0005,
    r: 37.7705,
    fill: "#0AB950",
    fillOpacity: 0.25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.7377,
    cy: 47.738,
    r: 28.8525,
    fill: "#0AB950"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5127 49.0125L40.5002 56L42.2627 54.225L35.2877 47.25M60.8002 39.225L47.5752 52.4625L42.3752 47.25L40.5877 49.0125L47.5752 56L62.5752 41M55.5002 41L53.7377 39.225L45.8002 47.1625L47.5752 48.925L55.5002 41Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptIcon);
export default __webpack_public_path__ + "static/media/promptIcon.627f405bae4f05d26280c2f9eba59795.svg";
export { ForwardRef as ReactComponent };